const balancePartnersTable = {
  columns: {
    getColumnsData: 'balancePartnersColumnsData',
    setColumnsData: 'setBalancePartnersColumnsData'
  },
  rows: {
    getRowsData: 'balancePartnersRowsData',
    setRowsData: 'setBalancePartnersRowsData'
  }
}

const balancePartnersTableColumns = [
  {
    id: 1,
    title: 'PARTNER NAME',
    property: 'partnerName.nickName',
    propertyWrite: 'partnerName',
    inputs: ['amountAED'],
    typeEditable: 'select',
    listName: 'partnersList',
    list: [],
    editable: true,
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 2,
    title: 'PROJECT NAME',
    inputs: ['amountAED'],
    property: 'projectName',
    editable: true,
    typeEditable: 'inputString',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 3,
    title: 'CLIENT NAME',
    inputs: ['amountAED'],
    property: 'clientName',
    editable: true,
    typeEditable: 'inputString',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 4,
    title: 'AMOUNT, AED',
    inputs: ['amountAED'],
    property: 'amountAED',
    editable: true,
    typeEditable: 'inputNumber',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 5,
    title: 'PAID',
    inputs: ['amountAED'],
    property: 'paid',
    type: 'toggle',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 7,
    property: 'action',
    inputs: ['amountAED'],
    actions: {
      edit: true,
      delete: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false
    }
  }
]

export {balancePartnersTable, balancePartnersTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/balancePartnersTable.js